import { Banner } from "@/components/ui/banner.tsx"
import { EditorView } from "@/components/ui/editor"

const CallLineBanner = ({ bannerInfo, testId }: { bannerInfo: string; testId?: string }) => {
  return (
    bannerInfo && (
      <Banner variant="info" className="gap-1 rounded-md px-4 py-2.5" data-testid={testId}>
        <div className="view-wrapper **:text-on-surface! **:break-normal! **:underline-offset-2">
          <EditorView initialValue={bannerInfo} />
        </div>
      </Banner>
    )
  )
}
export { CallLineBanner }
